/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Capacityrequesthint2Inputs */

const en_capacityrequesthint2 = /** @type {(inputs: Capacityrequesthint2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Places: once all are taken, new requests go on the waiting list.`)
};

const de_capacityrequesthint2 = /** @type {(inputs: Capacityrequesthint2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plätze: Wenn alle vergeben sind, kommen neue Anfragen auf die Warteliste.`)
};

/**
* | output |
* | --- |
* | "Places: once all are taken, new requests go on the waiting list." |
*
* @param {Capacityrequesthint2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const capacityrequesthint2 = /** @type {((inputs?: Capacityrequesthint2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Capacityrequesthint2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_capacityrequesthint2(inputs)
	return de_capacityrequesthint2(inputs)
});
export { capacityrequesthint2 as "capacityRequestHint" }